import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import urlService from '../services/urlService';
import './RedirectPage.css';  

const RedirectPage = () => {
  const { shortCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      try {
        // Add validation for shortCode
        if (!shortCode) {
          throw new Error('Invalid short code');
        }

        const longUrl = await urlService.redirectToLongUrl(shortCode);
        // Use replace instead of href to prevent adding to browser history
        window.location.replace(longUrl);
      } catch (error) {
        console.error('Redirect error:', error);
        // Add a small delay before redirecting to home
        // This allows users to see any error messages
        setTimeout(() => navigate('/'), 1500);
      }
    };

    redirect();
  }, [shortCode, navigate]);

  return (
    <div className="redirect-container">
      <div className="redirect-message">
        Redirecting...
      </div>
    </div>
  );
};

export default RedirectPage;
